import React, { useEffect } from 'react';
import './What.css';
import chiImage from './image/chi.png';
import Marquee from "react-fast-marquee";
import { Carousel, OverlayTrigger, Popover } from 'react-bootstrap';
import image1 from './image/z1.jpg';
import image2 from './image/z2.jpg';
import image3 from './image/z3.jpg';
import telegramImage from '../container/image/telegram.png';
import whatsappImage from '../container/image/whatsapp.png';
import instagramImage from '../container/image/instagram.png';
import phoneImage from '../container/image/phone.png'
import { Helmet } from 'react-helmet';
import socket from '../../service/socket';
import { getCookie, getUid } from '../../service/authCookie';
import { checkVisit } from '../../service/checkVisit';

const What = () => {

    let array = [
        {
            image: image1,
            caption: 'آهن آلات کهنه'
        },
        {
            image: image2,
            caption: 'پلاستیک کهنه، لوازم لاکی'
        },
        {
            image: image3,
            caption: 'کارتن، کاغد، کتاب و ...'
        },
    ];
    const popover = <Popover id="popover-basic">
        <Popover.Title as="h3">ارتباط با ما از طریق : </Popover.Title>
        <Popover.Content>
        <div className="popover-item">
            <span className=""> لینک تلگرام</span>
            <img src={telegramImage} alt="" style={{maxWidth:'30px'}} />
        </div>
        <div className="popover-item my-1">
            <span className="">لینک واتساپ</span>
            <img src={whatsappImage} alt="" style={{maxWidth:'34px'}} />
        </div>
        <div className="popover-item mb-1">
            <span className="">لینک اینستاگرام</span>
            <img src={instagramImage} alt="" style={{maxWidth:'31px'}} />
        </div>
        <div className="popover-item">
            <span className="">09903903847</span>
            <img src={phoneImage} alt="" style={{maxWidth:'33px'}} />
        </div>
        </Popover.Content>
    </Popover>
    useEffect(()=> {
        socket.emit("viewMessage", {
            location: window.location.href,
            authenticated: getCookie(),
            UID : getCookie() ? getUid() : null
        }, (response) => {
            if(response && response.status === 'New')
            checkVisit(response.uId)
        });
    },[]);
    return ( 
        <div className="bg-white py-3">
            <div className="container">
                <Helmet>
                    <title>3 دان | چی داری ؟ ، ضایعات ، تعمیرات ، کارتن ، کاغذ ، بطری ، پلاستیک ، لاک</title>
                </Helmet>
                <header className="d-flex flex-wrap justify-content-between align-items-between">
                    <div className="col-12 col-sm-4 px-0">
                        <img src={chiImage} alt="" className="main-image-top mr-1"/>
                        <small className="font-weight-bold">چی داری ؟ ( ضایعات )</small>
                    </div>
                </header>  
                <section>
                    <h5 className="text-center my-3">
                        <span className="text-success">«</span>
                        <span className="mx-1 font-weight-bold">ضایعات شما را خریداریم</span>
                        <span className="text-success">»</span>
                    </h5>
                    <div style={{direction:'ltr', textAlign:'left'}} className="text-white mt-3">
                        <Marquee
                            className="text-left"
                            direction="right"
                            speed={80}
                            style={{display:'inline', color:'#000'}}
                            gradient={false}
                        >
                            <p style={{fontSize:'1.1rem'}}>
                                <strong className=" mx-1">«</strong>
                                     آهن پاره ، لاک کهنه ، کارتن ، ضایعات کاغذی ،
                                    هر چی داری از درب منزل شما خریداریم
                                <strong className="mx-1">»</strong>
                            </p>
                            <p style={{width:'220px'}}></p>
                        </Marquee>
                    </div>
                    <div style={{maxWidth:'500px', direction:'ltr'}} className="mx-auto">
                        <Carousel>
                            {
                                array.map((item, index) => 
                                    <Carousel.Item interval={3000} key={index}>
                                        <img
                                            className="d-block w-100"
                                            src={item.image}
                                            alt="First slide"
                                        />
                                        <Carousel.Caption>
                                        <h4 className="slide-title">{item.caption}</h4>
                                        </Carousel.Caption>
                                    </Carousel.Item>
                                )
                            }
                        </Carousel>
                    </div>
                    <div className="text-center my-5">
                        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                            <button className="btn btn-success">
                                <i className="fa fa-shopping-basket mr-1"></i>
                                فروش ضایعات
                            </button>
                        </OverlayTrigger>
                    </div>
                </section>  
            </div>
        </div>
     );
}
 
export default What;